import { isRouteMatching } from '../../common'
import type { ExtensionConfig } from '../extension-config'

export const getStandaloneExtensionConfigForCurrentLocation = (
  extensionConfigs: readonly ExtensionConfig[],
  route: string,
) =>
  extensionConfigs.find(extensionConfig =>
    extensionConfig.standaloneRoutes?.some(pattern => isRouteMatching(route, pattern)),
  )

export const filterForStandaloneRoutes = (
  extensionConfigs: readonly ExtensionConfig[],
  route: string,
): readonly ExtensionConfig[] => {
  const matchingExtensionConfig = getStandaloneExtensionConfigForCurrentLocation(extensionConfigs, route)

  if (matchingExtensionConfig) {
    const requiredExtensions = new Set<string>()

    const addRequiredExtension = (config: ExtensionConfig) => {
      if (!requiredExtensions.has(config.id)) {
        requiredExtensions.add(config.id)

        const dependencies = config.dependencies ?? []

        dependencies.forEach(dependencyId => {
          const dependency = extensionConfigs.find(extensionConfig => extensionConfig.id === dependencyId)
          if (dependency) {
            addRequiredExtension(dependency)
          }
        })
      }
    }

    addRequiredExtension(matchingExtensionConfig)
    return extensionConfigs.filter(extensionConfig => requiredExtensions.has(extensionConfig.id))
  }
  return extensionConfigs
}
